<template>
  <div>
    <a-modal v-model="visible" title="上传LOGO" @ok="handleOk" @cancel="cancel">
      <a-upload
        :action="url"
        :headers="headers"
        list-type="picture-card"
        :file-list="fileList"
        @preview="handlePreview"
        @change="handleChange"
        :beforeUpload="handlerBeforeUpload"
        :multiple="false"
      >
        <div v-if="fileList.length < 1">
          <a-icon type="plus" />
          <div class="ant-upload-text">
            上传图片
          </div>
        </div>
      </a-upload>
      <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
        <img alt="example" style="width: 100%" :src="previewImage" />
      </a-modal>
    </a-modal>
  </div>
</template>

<script>
const baseUrl = process.env.VUE_APP_BASE_URL
import { getStorage } from '@/utils/index'
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}
export default {
  props: {
    visibleModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      previewVisible: false,
      previewImage: '',
      fileList: [],
      url: baseUrl + '/bus/financial/pop',
      headers: {},
      uploadTypeMap:
        'bmp,jpg , png , tif,gif,pcx,tga,exif,fpx,svg,psd,cdr,pcd,dxf,ufo,eps,ai,raw,WMF,webp,avif,apng,jpeg' // 请求的限制条件
    }
  },
  mounted() {
    const token = `${getStorage('token', 0)}`
    this.headers = {
      Authorization: token
    }
  },
  watch: {
    visibleModal(val) {
      this.visible = val
      this.fileList = []
    }
  },
  methods: {
    handlerBeforeUpload(file) {
      const { name } = file
      const type = name.split('.').slice(-1)
      // if(this.fileList.length >= 1) {
      //   this.$apiStatusHandler(99, '附件上传不能超过1个')
      //   return Promise.reject()
      // }
      if (this.uploadTypeMap.indexOf(type) === -1) {
        this.$apiStatusHandler(99, '上传的附件类型不符合要求')
        return Promise.reject()
      }
    },
    handleOk() {
      if (this.fileList.length > 0) {
        this.visible = false
        this.$emit('modalClose')
        this.$emit('uploadOk', this.fileList)
      } else {
        this.$message.warning('请上传图片!')
      }
    },
    cancel() {
      this.visible = false
      this.$emit('modalClose')
    },
    handleCancel() {
      this.previewVisible = false
    },
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },
    handleChange({ fileList }) {
      this.fileList = fileList
    }
  }
}
</script>
